import React from "react";
import styles from "./Documents.module.scss";
import { LuDownload } from "react-icons/lu";

export default function Documents({ emiDocs }) {
  return (
    <div className={styles.documents}>
      {emiDocs.map((item, index) => (
        <div className={styles.list} key={index}>
          <div>{item.text}</div>
          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.download}
          >
            <LuDownload size={25} color="#1f1f1f" />
          </a>
        </div>
      ))}
    </div>
  );
}
